import { isFinanceProject } from 'config';
import { useTranslation } from 'libs/i18n';
import { OnboardingRegistrationAddress } from 'modules/onboarding/common/components/OnboardingRegistrationAddress';

import { useRegistrationAddress } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const RegistrationAddressStep = ({ canGoBack }: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    submitDisabled,
    files,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
  } = useRegistrationAddress();

  const { step } = useOnboardingContext();
  const { t } = useTranslation();

  return (
    <OnboardingRegistrationAddress
      enabledFiles
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      enabledRegistrationAddress={isFinanceProject()}
      files={files}
      initialValues={initialValues}
      step={step}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={t(
        'onboarding.legalClientBeneficiary.registrationAddress.subtitle'
      )}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
